module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/APerfectSecreteBook2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("I’d like to acknowledge Beth Wiseman and Kathy Fuller, who were a treat to work with on this novella. These ladies are smart and supportive, as always! Thank you to Natalie Hanemann for her keen insight and to L.B. Norton for her deft editing. A big thanks to my critique partner, Brenda Lott, for her scene insight and to my mother-in-law, Donna Long, for her marketing support. As always, thank you to my Amish readers and especially to my family. I love you, Scott.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514d97d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/APerfectSecreteBook3.vue
// module id = 66
// module chunks = 0